import type { IExternalFormMultiselectItem } from 'components/ExternalFormMultiselect';
import type { RatioRowData } from 'gql/graphql';
import { RatioTypeEnum } from 'gql/graphql';

import { Checkbox } from '@consta/uikit/Checkbox';

interface ICoefficientRenderCheckbox {
    onRowCheckedChange: (item: IExternalFormMultiselectItem, isChecked: boolean) => void;
    checkedIds: number[];
    data: RatioRowData & { groupRow?: boolean };
    ratioType: RatioTypeEnum;
    hasSubGroupId: boolean;
    isWorkConditionsHasSubGroupId: boolean;
}

const isGroupIdInCheckedIds = (groupId: number, checkedIds: number[]): boolean => checkedIds.includes(groupId);

export const cellRenderCheckbox = (props: ICoefficientRenderCheckbox) => {
    const { onRowCheckedChange, checkedIds, data, ratioType, hasSubGroupId, isWorkConditionsHasSubGroupId } = props;

    const status = !!(checkedIds.length === 0 || !checkedIds.includes(data?.id));

    const disabledNotGroupRow = () => {
        if (ratioType === RatioTypeEnum.DismantlingCoef) {
            return hasSubGroupId === false ? !data?.groupRow : false;
        }

        return !data?.groupRow && ratioType !== RatioTypeEnum.TechPartCoef;
    };

    const checked = checkedIds.includes(data?.id) || isGroupIdInCheckedIds(data?.groupId, checkedIds);

    const isNotShowCheckbox =
        isWorkConditionsHasSubGroupId && data?.groupRow === true && ratioType === RatioTypeEnum.DismantlingCoef;

    return (
        <div>
            {!isNotShowCheckbox && (
                <Checkbox
                    className="CheckboxFocus"
                    checked={checked}
                    onChange={() => onRowCheckedChange({ id: Number(data?.id), label: data?.code, data }, status)}
                    disabled={disabledNotGroupRow()}
                />
            )}
        </div>
    );
};

cellRenderCheckbox.displayName = 'cellRenderCheckbox';
